<template>
  <div>
    <el-card>

      <!-- 顶部搜索 + 新增 -->
      <div style="margin-bottom: 15px; display: flex; justify-content: space-between; align-items: center;">
        <div>
          <el-input
            placeholder="请输入项目名"
            v-model="query.projectName"
            clearable
            style="width: 220px; margin-right: 10px;"
          />

          <el-button type="primary" @click="loadData(1)">查询</el-button>
          <el-button type="primary" @click="openDialog()">新增项目</el-button>
        </div>
      </div>

      <!-- 表格 -->
      <el-table :data="tableData" border stripe>
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="pqProjectName" label="项目名" />
        <el-table-column prop="landingPageUrl" label="落地页URL" />

        <!-- 转归因名称 -->
        <el-table-column label="归因行为">
          <template slot-scope="scope">
            {{ getAttributionName(scope.row.attributionCode) }}
          </template>
        </el-table-column>

<!--        <el-table-column prop="creatorUid" label="创建者UID" />-->
        <el-table-column label="状态" width="120">
          <template slot-scope="scope">
            <el-switch
                v-model="scope.row.status"
                active-value="ON"
                inactive-value="OFF"
                @change="changeStatus(scope.row)"
            />
          </template>
        </el-table-column>

        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button type="text" @click="openDialog(scope.row)">编辑</el-button>
            <el-button type="text" @click="openMonitorDialog(scope.row)">查看</el-button>



            <el-button type="text" @click="deleteItem(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        layout="prev, pager, next"
        :current-page="page"
        :page-size="size"
        :total="total"
        @current-change="loadData"
      />
    </el-card>

    <!-- 弹窗 -->
    <el-dialog :visible.sync="dialogVisible" title="项目配置">
      <el-form :model="form" label-width="120px">

        <el-form-item label="项目名">
          <el-input v-model="form.pqProjectName" />
        </el-form-item>

        <el-form-item label="落地页URL">
          <el-input v-model="form.landingPageUrl" />
        </el-form-item>

        <el-form-item label="归因行为">
          <el-select v-model="form.attributionCode" placeholder="选择行为" style="width: 100%;">
            <el-option
              v-for="item in attributionList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="任务状态">
          <el-switch
              v-model="form.status"
              active-value="ON"
              inactive-value="OFF"
              active-text="开启"
              inactive-text="关闭"
          />
        </el-form-item>


      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </span>
    </el-dialog>


    <!-- 监控记录弹窗 -->
    <el-dialog
        :visible.sync="monitorDialogVisible"
        title="监控记录"
        width="80%"
    >
      <!-- 🔍 查询栏 -->
      <div style="margin-bottom: 15px;">
        <el-date-picker
            v-model="monitorDateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="margin-right: 10px; width: 260px;"
        ></el-date-picker>

        <el-input
            v-model="monitorWxName"
            placeholder="微信名称"
            style="width:200px; margin-right:10px;"
        ></el-input>

        <el-button type="primary" @click="loadMonitorData(1)">查询</el-button>
      </div>

      <!-- 表格 -->
      <el-table :data="monitorTableData" v-loading="monitorLoading" border stripe>

        <el-table-column prop="visitor_id" label="IP地址" width="150"/>
        <el-table-column prop="area_str" label="地区" width="150"/>

        <el-table-column prop="access_time" label="访问时间" width="180">
          <template slot-scope="scope">
            {{ new Date(scope.row.access_time).toLocaleString() }}
          </template>
        </el-table-column>

        <el-table-column prop="visit_count" label="访问次数" width="100"/>

        <!-- 行为列 -->
        <el-table-column label="行为">
          <template slot-scope="scope">
            <span v-if="scope.row.long_press == 1">长按识别二维码</span>
            <span v-if="scope.row.add_friend == 1" style="color: green">API添加好友</span>
          </template>
        </el-table-column>

        <!-- 添加人微信头像 + 名字 -->
        <el-table-column label="添加人微信" width="220">
          <template slot-scope="scope">
            <img v-if="scope.row.add_friend == 1" :src="scope.row.addfen_wx_avtor"
                 style="width:30px; height:30px; border-radius:50%; margin-right:6px;">
            <span>{{ scope.row.addfen_wxname }}</span>
          </template>
        </el-table-column>

        <!-- 是否上报 -->
        <el-table-column label="是否上报" width="120">
          <template slot-scope="scope">
            <el-tag :type="scope.row.report_status == 1 ? 'success' : 'info'">
              {{ scope.row.report_status == 1 ? '已上报' : '未上报' }}
            </el-tag>
          </template>
        </el-table-column>

      </el-table>

      <!-- 分页 -->
      <div style="text-align: center; margin-top: 20px;">
        <el-pagination
            layout="prev, pager, next"
            :current-page="monitorPage"
            :page-size="monitorSize"
            :total="monitorTotal"
            @current-change="loadMonitorData"
        />
      </div>
    </el-dialog>


  </div>

</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      uid: this.$route.query.uid,   // ⭐ 路由上带来的 uid


      monitorDialogVisible: false,
      monitorProjectId: null,
      monitorPage: 1,
      monitorSize: 20,
      monitorTotal: 0,
      monitorTableData: [],
      monitorLoading: false,
      monitorReportStatus: '',  // 是否上报筛选（'' 表示全部）
      monitorDateRange: null,   // 日期范围
      monitorWxName: '',        // 微信名称模糊查询


      page: 1,
      size: 10,
      total: 0,
      tableData: [],
      dialogVisible: false,

      query: {
        projectName: ""
      },

      form: {},

      /** 归因列表（完整保留） */
      attributionList: [
        { code: 10001, name: "报名" },
        { code: 10002, name: "入群（新用户）" },
        { code: 10003, name: "退群" },
        { code: 10004, name: "加企业微信" },
        { code: 10005, name: "加个人微信" },
        { code: 10006, name: "咨询企业微信" },
        { code: 10007, name: "咨询个人微信" },
        { code: 10008, name: "下单" },
        { code: 10009, name: "创建订单" },
        { code: 10010, name: "支付成功" },
        { code: 10011, name: "订单发货" },
        { code: 10012, name: "确认收货" },
        { code: 10013, name: "取消订单" },
        { code: 10014, name: "退款" },
        { code: 10015, name: "退货退款" },
        { code: 10016, name: "退款成功" },
        { code: 10017, name: "用户到课" },
        { code: 10018, name: "正价课购买" },
        { code: 10019, name: "扫码" },
        { code: 11002, name: "入群（老用户）" }
      ]
    };
  },

  created() {
    this.loadData(1);
  },

  methods: {
    openMonitorDialog(row) {
      this.monitorProjectId = row.id;
      this.monitorDialogVisible = true;
      this.loadMonitorData(1);
    },
    loadMonitorData: function (page) {
      if (typeof page === 'undefined') {
        page = 1;
      }

      this.monitorPage = page;
      this.monitorLoading = true;

      // 处理日期范围：把选中的日期区间扩展为 日 0:00:00 到 日 23:59:59.999
      var start = null;
      var end = null;

      if (this.monitorDateRange && this.monitorDateRange.length === 2) {
        try {
          var d0 = new Date(this.monitorDateRange[0]);
          d0.setHours(0, 0, 0, 0); // 当天 00:00:00.000
          start = d0.getTime();

          var d1 = new Date(this.monitorDateRange[1]);
          d1.setHours(23, 59, 59, 999); // 当天 23:59:59.999
          end = d1.getTime();
        } catch (e) {
          start = null;
          end = null;
        }
      }

      axios.get("https://control.zjwec.cn/api/pqmonitor/list", {
        params: {
          projectId: this.monitorProjectId,
          page: this.monitorPage,
          size: this.monitorSize,
          report_status: this.monitorReportStatus !== '' ? this.monitorReportStatus : undefined,
          startTime: start,
          endTime: end,
          wxName: this.monitorWxName && this.monitorWxName.trim().length > 0 ? this.monitorWxName : undefined
        },
        headers: {
          uid: this.uid
        }
      })
          .then(function (res) {
            this.monitorLoading = false;
            var data = res.data || {};
            this.monitorTableData = data.records || [];
            this.monitorTotal = data.total || 0;
          }.bind(this))
          .catch(function (err) {
            this.monitorLoading = false;
            this.$message.error("请求监控数据失败");
            console.error(err);
          }.bind(this));
    },

    getAttributionName(code) {
      const found = this.attributionList.find(item => item.code === code);
      return found ? found.name : code;
    },
    changeStatus(row) {
      axios.post("https://control.zjwec.cn/api/project/update", row, this.withUidHeader())
          .then(res => {
            if (res.data.code === "0") {
              this.$message.success("状态已更新");
            } else {
              this.$message.error(res.data.msg);
            }
          });
    },

    /** ⭐ 统一携带 uid */
    withUidHeader() {
      return {
        headers: {
          uid: this.uid
        }
      };
    },

    /** 加载分页数据 */
    loadData(page = 1) {
      this.page = page;

      axios.get("https://control.zjwec.cn/api/project/list", {
        params: {
          page: this.page,
          size: this.size,
          projectName: this.query.projectName
        },
        headers: {
          uid: this.uid
        }
      }).then(res => {
        if (res.data.code !== "0") {
          this.$message.error(res.data.msg);
          return;
        }

        const pageData = res.data.data;
        this.tableData = pageData.records;
        this.total = pageData.total;
      });
    },

    openDialog(row) {
      this.form = row ? { ...row } : { status: "ON" }; // ⭐ 默认开启
      this.dialogVisible = true;
    },

    save() {
      const url = this.form.id
        ? "https://control.zjwec.cn/api/project/update"
        : "https://control.zjwec.cn/api/project/add";

      axios.post(url, this.form, this.withUidHeader()).then(res => {
        if (res.data.code === "0") {
          this.$message.success("保存成功");
          this.dialogVisible = false;
          this.loadData(this.page);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },

    deleteItem(id) {
      this.$confirm("确认删除该项目？", "提示", { type: "warning" })
        .then(() => {
          axios.delete(`https://control.zjwec.cn/api/project/delete/${id}`, this.withUidHeader())
            .then(res => {
              if (res.data.code === "0") {
                this.$message.success("删除成功");
                this.loadData(this.page);
              } else {
                this.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {});
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/piaoquan/pqpjcontrol.vue